import React from "react";

type Props = {
  onClick?: React.MouseEventHandler;
  fill?: string;
  styles?:object
};

const ErrorIcon = (props: Props) => {
  const { onClick, fill = "var(--cta-clr-text)",styles } = props;

  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4572 7C13.4572 10.5662 10.5662 13.4572 6.99999 13.4572C3.43378 13.4572 0.542786 10.5662 0.542786 7C0.542786 3.43378 3.43378 0.542793 6.99999 0.542793C10.5662 0.542793 13.4572 3.43378 13.4572 7ZM6.99999 10.6329C7.41421 10.6329 7.74999 10.2971 7.74999 9.88288C7.74999 9.46867 7.41421 9.13288 6.99999 9.13288H6.99279C6.57857 9.13288 6.24279 9.46867 6.24279 9.88288C6.24279 10.2971 6.57857 10.6329 6.99279 10.6329H6.99999ZM6.24999 7C6.24999 7.41421 6.58578 7.75 6.99999 7.75C7.41421 7.75 7.74999 7.41421 7.74999 7V4.11712C7.74999 3.7029 7.41421 3.36712 6.99999 3.36712C6.58578 3.36712 6.24999 3.7029 6.24999 4.11712V7Z" fill="#E03923"/>
    </svg>
  );
};

export default ErrorIcon;

